export default __webpack_public_path__ + "images/fc24d8a7b0cf8b3c093fba9a3f20f634-after_school_care.jpg";